module.exports = __webpack_public_path__ + "img/profile-subscription-inactive.2863ca5d.svg";